
import React from 'react';

import * as styles from './styles.module.scss';

export const Circles = () => {
	return (
		<>
			<div className={styles.primary} />
			<div className={styles.secondary} />
		</>
	);
};
